export const CONFIGURATION_CODES = ['7000218', '700025', '700027', '50011', '50020'];
